import type { PublicParticipantSnapshot } from '../../../domain/leaderboard/models/public-participant.model';
import type { PublicParticipantApiData } from '../dtos/leaderboard-public-api.dto';

export function mapParticipantApiToSnapshot(
  data: PublicParticipantApiData | undefined | null,
): PublicParticipantSnapshot | null {
  const uid = String(data?.uid ?? '').trim();
  if (!data || !uid) {
    return null;
  }
  return {
    uid,
    isActive: Boolean(data.is_active),
  };
}
